import { Aurelia, PLATFORM } from 'aurelia-framework';
export function configure(aurelia: any) {
	aurelia
		.globalResources(PLATFORM.moduleName('./busy-indicator'))
		.globalResources(PLATFORM.moduleName('./language-selector'))
		.globalResources(PLATFORM.moduleName('./location-management'))
		.globalResources(PLATFORM.moduleName('./measurement-system-selector'))
		.globalResources(PLATFORM.moduleName('./navmenu'))
        .globalResources(PLATFORM.moduleName('./notification-status-selector'))
		.globalResources(PLATFORM.moduleName('./notification-type-selector'))
		.globalResources(PLATFORM.moduleName('./signal-mapping-header'))
		.globalResources(PLATFORM.moduleName('./asset-tracking-header'))
		.globalResources(PLATFORM.moduleName('./temperature-scale-selector'))
        .globalResources(PLATFORM.moduleName('./water-tank'));
}